<template>
  <v-card flat>

    <v-card-text>
      <v-form
        v-model="personalInfoValid"
        @keyup.native.enter="editPersonalInfo">

        <v-text-field
          v-model="userObj.first_name"
          :label="$t('firstName') + '*'"
          :rules="[$rules.isRequired]"
          :error-messages="errorMessages.first_name"
        />

        <v-text-field
          v-model="userObj.last_name"
          :error-messages="errorMessages.last_name"
          :rules="[$rules.isRequired]"
          :label="$t('lastName') + '*'"
        />

        <v-select
          v-model="userObj.lang"
          :items="languagesList"
          :label="$t('selectLanguage') + '*'"
          :return-object="true"
          :error-messages="errorMessages.lang_id"
          item-text="name"
          item-value="id"
          menu-props="auto"
          hide-details
          @change="setI18nLanguage"
        >
          <template
            slot="selection"
            slot-scope="data">
            {{ langNames[data.item.name] }}
          </template>
          <template
            slot="item"
            slot-scope="data">
            {{ langNames[data.item.name] }}
          </template>
        </v-select>

      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading || !personalInfoValid"
        color="primary"
        @click="editPersonalInfo"
      >
        {{ $t('edit') }}
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserApi from '@/api/UserApi'

import { setI18nLanguage } from '@/locales/i18n-setup'

export default {
  name: 'PersonalInfoSettings',
  props: [],
  data () {
    return {
      userObj: {},
      errorMessages: {},
      languages: [],
      isLoading: false,
      personalInfoValid: true,
      langNames: {
        en: 'English',
        ru: 'Русский',
        de: 'Deutsch',
        tr: 'Türkçe'
      }
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser',
      languagesList: 'languages/languagesList'
    })
  },
  methods: {
    ...mapActions({
      updateUser: 'user/updateUser',
      setLanguages: 'languages/setLanguages'
    }),
    setUserObj () {
      this.userObj = Object.assign({}, this.getUser)
    },
    setI18nLanguage () {
      setI18nLanguage(this.userObj.lang.name)
    },
    async editPersonalInfo () {
      if (this.personalInfoValid) {
        this.isLoading = true
        try {
          const result = await UserApi.updateUser({
            first_name: this.userObj.first_name,
            last_name: this.userObj.last_name,
            lang_id: this.userObj.lang.id
          })

          await this.updateUser()
          this.$notification(result)
        } catch (e) {
          this.errorMessages = e.errors
        }
        this.isLoading = false
      }
    }
  },
  watch: {
    userObj: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  i18n: {
    messages: {
      en: {
        edit: 'Save personal data',
        firstName: 'First name',
        lastName: 'Last name',
        selectLanguage: 'Select language'
      },
      tr: {
        edit: 'Kişisel bilgilerinizi kaydedin',
        firstName: 'İsim',
        lastName: 'Soyisim',
        selectLanguage: 'Dil seçiniz'
      },
      de: {
        edit: 'Speichern',
        firstName: 'Vorname',
        lastName: 'Nachname',
        selectLanguage: 'Sprache wählen'
      },
      ru: {
        edit: 'Сохранить персональные данные',
        firstName: 'Имя',
        lastName: 'Фамилия',
        selectLanguage: 'Выберите язык'
      }
    }
  },
  created () {
    this.setLanguages()
    this.setUserObj()
  }
}
</script>
